import { requestGet } from '@/common/request';

export interface permissionParams {
  roomId: string;
}

export interface permissionRes {
  ret: string;

  msg: string;

  data: {
    role: number;

    modules: {
      tabs: {
        tower_activity: number;

        tibao_activity: number;

        audit_management: number;

        applied_material: number;

        process_data: number;

        effect_data: number;
      };

      functions: {
        tower_activity: {
          tower_header_info: number;

          tower_activity_change: number;

          tower_activity_entrance: number;

          tower_data_display: number;

          tower_activity_link: number;

          tower_activity_create: number;

          tower_page_setup: number;

          tower_page_list: number;
        };

        room_header: {
          room_header: number;

          room_member_management: number;

          room_info_modify: number;
        };
      };
    };
  };
}

//会场运营 - 获取会场角色以及需显示的模块

export async function permission(params: permissionParams): Promise<permissionRes> {
  return await requestGet('/room/permission', params);
}
